import { useState } from "react"
import ResolvedAddress from "../ResolvedAddress"
import { copyText } from "@src/lib/copyText"
import Copy from "../../icons/Copy"

type Props = {
  slicerAddress: `0x${string}`
  showIcon?: boolean
  position?: string
}

const CopyAddress = ({ slicerAddress, showIcon = true, position }: Props) => {
  const [showAlert, setShowAlert] = useState(false)

  return slicerAddress ? (
    <div className="sl-inline-block">
      <div className="sl-relative sl-flex sl-items-center sl-justify-center sl-w-full">
        {showIcon ? (
          <div className="sl-flex sl-items-center sl-justify-center">
            <p className="sl-text-sm">
              <ResolvedAddress address={slicerAddress} />
            </p>
            <div
              className="sl-inline-block sl-pl-2 sl-cursor-pointer sl-highlight"
              onClick={async () => await copyText(slicerAddress, setShowAlert)}
            >
              <Copy className="sl-w-5 sl-h-5" />
            </div>
          </div>
        ) : (
          <div
            className="sl-flex sl-items-center sl-justify-center sl-cursor-pointer sl-highlight"
            onClick={async () => await copyText(slicerAddress, setShowAlert)}
          >
            <p className="sl-inline-block sl-text-sm sl-font-medium">
              {slicerAddress.replace(
                slicerAddress.substring(5, slicerAddress.length - 3),
                `\xa0\xa0\xa0\xa0\xa0\xa0`
              )}
            </p>
          </div>
        )}
        <div
          className={`sl-w-40 sl-absolute sl-p-2 ${
            position
              ? position
              : "sl-top-[40px] sm:sl-top-[auto] sm:sl-right-[-180px]"
          } sl-shadow-md sl-rounded-md sl-overflow-hidden sl-flex sl-justify-center sl-items-center sl-text-white sl-bg-gray-800 sl-transition-opacity sl-duration-100 ${
            showAlert ? "" : "sl-hidden"
            // showAlert ? "opacity-100 z-20" : "opacity-0 -z-10"
          }`}
        >
          <p className="sl-text-sm">Address copied!</p>
        </div>
      </div>
    </div>
  ) : null
}

export default CopyAddress
